

































































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "AreaWidget",
  components: {
    selectComponent: () =>
      import("../../../components/SelectComponent/index.vue"),
    MagicValidator
  }
})
export default class AreaWidget
  extends EventWidgetComponent
  implements
    App.PuttedWidgetComponent,
    App.LinkedWidgetComponent,
    App.PutAbleWidgetComponent
{
  private show: boolean = false;

  putModel: any = {};
  params: App.LinkedWidgetComponentParam[] = [];

  initText() {
    if (this.value) {
      const ext = Array.isArray(this.widget.ext)
        ? this.widget.ext
        : [this.widget.ext];
      const str: any[] = [];
      ext.map((i: any) => {
        str.push(i.adFullName);
      });
      this.widget.text = str.join("、");
    }
  }

  reset() {
    this.widget.text = "";
    this.value = "";

    this.putModel = { adCode: this.value, adName: this.widget.text };
    this.handleEvent(this.value);
  }

  refresh(option: App.LinkEventOption) {
    this.params = [
      {
        key: option.property,
        value: option.value
      }
    ];

    this.reset();
  }

  setValue(value: string) {
    // this.reset();

    if (!/[0-9]+/.test(value)) {
      this.value = "";
      this.widget.text = "";
      this.putModel = undefined;
    } else {
      this.value = value.split(",")[0];
      this.widget.text = value.split(",")[1];
      this.putModel = { adCode: this.value, adFullName: this.widget.text };
    }

    this.handleEvent(this.value);
  }

  confirm(data: any) {
    // if (!data.source.length) return false;
    this.widget.ext = data.source;
    const item = data.source[0];
    this.putModel = item;
    this.widget.text = data.source.map((d: any) => d.adFullName).join("、");
    this.handleEvent(this.value);
  }

  created() {
    this.initText();
  }

  async showHandler() {
    if (!this.widget.readonly) {
      this.show = true;
    }
  }
}
